import axios from 'axios';
import keys from './keys';
import { useQuery } from '@tanstack/react-query';

const useGetPlans = ({ fromPlan }) => {
  const query = useQuery({
    queryKey: keys.plans(fromPlan),
    queryFn: async () => {
      const resPlan = await axios.get(`/public/plan/${fromPlan}`);
      const planData = resPlan?.data;
      const searchParams = new URLSearchParams();

      if (planData?.metadata?.cms_type) {
        searchParams.append('type', planData.metadata.cms_type);
      }
      if (planData?.product) {
        searchParams.append('product', planData.product);
      }
      const res = await axios.get(`/public/plans?${searchParams.toString()}`);
      return res.data;
    },
    enabled: !!fromPlan,
  });

  return {
    plans: query?.data,
    plansError: query.error,
    IsPlansFetchError: query.isError,
    isPlansFetchSuccess: query.isSuccess,
    isPlansFetching: query.isFetching,
    isPlansLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetPlans;
